import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import Button from 'react-bootstrap/Button';
import {
  ApprovalFilterType,
  ColXsMdType,
  LocationFilterType,
} from '../utils/Types';
import { DEFAULT_OPTION_LOCATION } from '../utils/Constant';
import LocationFilter from './LocationFilter';

interface IApproveFilterProps {
  onApplyFilters: (approvalFilter: ApprovalFilterType) => void;
}

const defaultFilter: ApprovalFilterType = {
  candidateId: '',
  candidateName: '',
  pincode: '',
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
};
const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};
const ApproveFilter: React.FunctionComponent<IApproveFilterProps> = ({
  onApplyFilters,
}) => {
  const [approvalFilter, setApprovalFilter] =
    useState<ApprovalFilterType>(defaultFilter);

  const onResetFilter = () => {
    onApplyFilters(defaultFilter);
    setApprovalFilter(defaultFilter);
  };
  return (
    <div className="border rounded ps-3 pt-2 pe-3">
      <Row>
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Candidate Id"
            placeHolder="Ex. 1001001"
            value={approvalFilter.candidateId}
            onChange={(e: any) => {
              setApprovalFilter({
                ...approvalFilter,
                candidateId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Candidate Name"
            placeHolder="Ex. John Doe"
            value={approvalFilter.candidateName}
            onChange={(e: any) => {
              setApprovalFilter({
                ...approvalFilter,
                candidateName: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={12} md={8}>
          <LocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: approvalFilter.zone,
              state: approvalFilter.state,
              district: approvalFilter.district,
              city: approvalFilter.city,
            }}
            setLocationFilter={(filter: LocationFilterType) => {
              setApprovalFilter({
                ...approvalFilter,
                zone: filter.zone,
                state: filter.state,
                district: filter.district,
                city: filter.city,
              });
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col
          xs={12}
          md={4}
          className="d-flex align-items-center pt-1 p-3 filter-button-parent"
        >
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={() => {
              onApplyFilters(approvalFilter);
            }}
          >
            Search
          </Button>
          <Button
            variant="outline-primary"
            className="mx-2 cl-btn-outline-primary"
            onClick={() => {
              onResetFilter();
            }}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ApproveFilter;
